module.exports = function getResource(label, vars = []) {
    let resources = {
        youNowHaveText: 'You now have ',
        youAreExceeding: 'You are exceeding by',
        beautyInsiderPointsText: ' Beauty Insider points',
        earnText: 'and earn ',
        todayText: ' today',
        redeemYourRewardsText: 'Redeem your rewards',
        redeemYourRewardsLowerCaseText: 'redeem your rewards',
        joinBeautyInsiderText: 'Join Beauty Insider',
        joinText: 'Join',
        beautyInsiderText: 'Beauty Insider',
        signInText: 'Sign in',
        toSeeYourBeautyInsiderPointsText: 'to see your Beauty Insider points',
        rewardsAddedText: `${vars[0]} reward${vars[0] !== 1 ? 's' : ''} added`,
        pointsRemainingText: ' points remaining',
        viewAllRewardsText: 'View all rewards',
        pointsText: 'points'
    };

    return resources[label];
};
